import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import MaterialTable from 'material-table';
import DraggableModal from '../UI/DraggableModal';
import useAPI from '../../hooks/useAPI';
import { getHistoryOperationDescription } from '../../helpers/receipts';
import { localization, modifyDefaultOptions } from '../../helpers/table';

export default function ContractHistory({ show, onHide, contractId }) {
  const [history, setHistory] = useState([]);
  const api = useAPI();

  const handleClose = useCallback(() => {
    onHide();
    setHistory([]);
  }, [onHide]);

  useEffect(() => {
    const getHistory = async () => {
      const response = await api.get(`/factdata/contracts/${contractId}/hists`);
      setHistory(response);
    };
    if (contractId) {
      getHistory();
    }
  }, [contractId]);

  return (
    <DraggableModal show={show} onHide={handleClose} headerNode="История изменений" size="lg">
      <Modal.Body>
        <MaterialTable
          columns={[
            {
              title: 'Дата, время',
              field: 'createdOn',
              render: (rowData) => {
                const [date, time] = rowData.createdOn.split('T');
                const ruDate = date.split('-').reverse().join('.');
                return `${ruDate}`;
              },
            },
            {
              title: 'Реквизиты доп. соглашения',
              field: 'title',
            },
            {
              title: 'Изменения',
              field: 'changes',
              cellStyle: {
                minWidth: 400,
              },
              render: (rowData) => (
                <ul>
                  {getHistoryOperationDescription(rowData.changes).map((description, i) => (
                    <li key={i}>
                      {description}
                    </li>
                  ))}
                </ul>
              ),
            },
          ]}
          data={history}
          localization={localization}
          options={modifyDefaultOptions({
            filtering: false,
            sorting: false,
            toolbar: false,
          })}
        />
      </Modal.Body>
    </DraggableModal>
  );
}
